if (!customElements.get('primary-hero')) {
  class PrimaryHero extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.querySelectorAll('.hero-video').forEach((video) => {
        if (video.readyState >= 2) {
          this.showVideo(video);
        } else {
          video.addEventListener('canplay', () => this.showVideo(video), { once: true });
        }
      });

      this.addEventListener('click', (event) => {
        const actionElement = event.target.closest('[data-action]');
        if (!actionElement) return;

        event.preventDefault();
        event.stopPropagation();

        const { action } = actionElement.dataset;
        if (action === 'mute') {
          this.setMuted(true);
        } else if (action === 'unmute') {
          this.setMuted(false);
        }
      });
    }

    setMuted(muted) {
      this.querySelectorAll('.hero-video').forEach((video) => {
        video.muted = muted || video.offsetParent === null;
      });
      this.setAttribute('data-muted', muted ? 'muted' : 'unmuted');
    }

    showVideo(video) {
      video.classList.remove('opacity-0');
    }
  }

  customElements.define('primary-hero', PrimaryHero);
}
